import { render } from "./SetMeal.vue?vue&type=template&id=32225402&scoped=true"
import script from "./SetMeal.vue?vue&type=script&lang=js"
export * from "./SetMeal.vue?vue&type=script&lang=js"

import "./SetMeal.vue?vue&type=style&index=0&id=32225402&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32225402"]])

export default __exports__